import { Component, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { TranslationService } from '../../../../shared/translations/services/translation.service';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { hasRolePermission } from '../../utils/UserSetupUtils';
import { ROLES } from '../../../authentication/authRoles.constants';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subject, takeUntil } from 'rxjs';
import { UserTabService } from '../../services/user-tab.service';

@Component({
  selector: 'app-user-setup',
  templateUrl: './user-setup.component.html',
  styleUrl: './user-setup.component.scss',
  standalone: false
})
export class UserSetupComponent implements OnInit, OnDestroy {
  protected readonly hasRolePermission = hasRolePermission;
  protected readonly ROLES = ROLES;
  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;
  selectedTabIndex = 0;
  tabRouteLink = '/setup/usersetup';
  private readonly destroy$ = new Subject<void>();
  private skipNextNavigation = false;

  protected translationService = inject(TranslationService);
  private readonly router = inject(Router);
  private userTabService = inject(UserTabService);

  constructor() {}

  ngOnInit(): void {
    this.updateSelectedTabIndex(this.router.url);

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => {
        this.updateSelectedTabIndex(event.urlAfterRedirects);
      });

    this.userTabService.tabReset$.pipe(takeUntil(this.destroy$)).subscribe((tabIndex) => {
      console.log('Tab reset requested to:', tabIndex);

      this.skipNextNavigation = true;

      this.selectedTabIndex = tabIndex;
    });
  }

  private updateSelectedTabIndex(url: string): void {
    this.selectedTabIndex = url.includes('/user-group') ? 1 : 0;
  }

  onTabChange(event: MatTabChangeEvent) {
    this.selectedTabIndex = event.index;
    if (this.skipNextNavigation) {
      this.skipNextNavigation = false;
      return;
    }
    switch (event.index) {
      case 0:
        this.router.navigate(['home/setup/usersetup']);
        this.tabRouteLink = '/setup/usersetup';
        break;
      case 1:
        this.router.navigate(['home/setup/usersetup/user-group']);
        this.tabRouteLink = '/setup/usersetup/user-group';
        break;
      default:
        this.router.navigate(['home/setup/usersetup']);
        this.tabRouteLink = '/setup/usersetup';
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
